import * as React from "react"
const Saved = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill={props.fill ? props.fill : "none"}
    {...props}
  >
    <path
      stroke={props.color ? props.color : "#202327"}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M3.333 14.984V8.09c0-3.028 0-4.542.977-5.482.976-.941 2.547-.941 5.69-.941 3.143 0 4.714 0 5.69.94.977.941.977 2.455.977 5.483v6.894c0 1.922 0 2.883-.644 3.227-1.248.666-3.587-1.556-4.698-2.225-.644-.388-.966-.582-1.325-.582-.358 0-.68.194-1.325.582-1.111.669-3.45 2.89-4.698 2.225-.644-.344-.644-1.305-.644-3.227Z"
    />
  </svg>
)
export default Saved
